/* eslint-disable no-underscore-dangle */
// underscore-dangle é uma convenção adotada pelo leafelt para atributos privados

import { Canvas } from 'leaflet';

// Adicionando método setZIndex para possibilitar sobreposição de camadas geoJson na mesma pane
Canvas.include({
  setZIndex: function (zIndex) {
    if (this._container) this._container.style.zIndex = zIndex;
  },
});
